/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Notification_Agent_Run_CancelledInputs */



/**
* | output |
* | --- |
* | "A run of {name} was cancelled" |
*
* @param {Notification_Agent_Run_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_agent_run_cancelled = /** @type {((inputs: Notification_Agent_Run_CancelledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Agent_Run_CancelledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Lauf von ${i?.name} wurde abgebrochen.`)
	return /** @type {LocalizedString} */ (`A run of ${i?.name} was cancelled`)
});